import React from "react";
import "./result-table.style.scss";

const productOptions = [
  "Product 01",
  "Product 02",
  "Product 03",
  "Product Offering",
  "Product Protential",
];

const initialProducts = [
  {
    label: "Product 01",
    name: "Corporate-034-Bao thanh toán",
    editable: false,
    interestRate: "7,34%",
    ead: "9.875.100.000",
    toi: "606.893.607",
    provision: "(4.740.048)",
    cof: "(480.634.533)",
    beforeTax: "121.519.026",
    tax: "(24.303.805)",
    afterTax: "97.215.221",
    rwa: "7.618.367.607",
    raroc: "32,38%",
    rorwa: "2,59%",
  },
  {
    label: "Product 02",
    name: "Corporate-011-Cho vay tài trợ vốn SXKD",
    editable: false,
    interestRate: "9,68%",
    ead: "299.810.000",
    toi: "21.492.345",
    provision: "(143.909)",
    cof: "(12.848.618)",
    beforeTax: "8.499.818",
    tax: "(1.699.964)",
    afterTax: "6.799.854",
    rwa: "231.295.155",
    raroc: "",
    rorwa: "",
  },
  {
    label: "Product 03",
    name: "Corporate-411-Tài khoản thấu chi",
    editable: false,
    interestRate: "8,66%",
    ead: "186.644.120",
    toi: "11.701.810",
    provision: "(89.589)",
    cof: "(8.070.474)",
    beforeTax: "3.541.748",
    tax: "(708.350)",
    afterTax: "2.833.398",
    rwa: "143.990.797",
    raroc: "",
    rorwa: "",
  },
  {
    label: "Product Offering",
    name: "Corporate-009-Cho vay đầu tư TSCĐ",
    editable: "interestOnly",
    interestRate: "7,49%",
    ead: "1.200.000.000",
    toi: "59.225.647",
    provision: "(576.000)",
    cof: "(46.800.000)",
    beforeTax: "11.849.647",
    tax: "(2.369.929)",
    afterTax: "9.479.717",
    rwa: "668.689.859",
    raroc: "",
    rorwa: "",
  },
];

const rowKeys = [
  "interestRate",
  "ead",
  "toi",
  "provision",
  "cof",
  "beforeTax",
  "tax",
  "afterTax",
  "rwa",
];

const rowLabels = [
  "interest rate",
  "EAD",
  "estimated annualized TOI",
  "Provision/EL",
  "COF",
  "Net Contributed Before Tax",
  "- Taxes @ 20%",
  "Net Contributed After Tax",
  "RWA",
];

class ProductFinancialTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      products: initialProducts,
    };
  }

  handleInputChange = (index, key, value) => {
    const updated = [...this.state.products];
    updated[index][key] = value;
    if (index <= 2) this.setState({ products: updated });
    const objKeyVal = updated[index];
    const totalLength = updated.length;
    let needRecal = true;
    for (const key in objKeyVal) {
      const val = objKeyVal[key];
      if (key !== "raroc" && key !== "rorwa" && key !== "name" && !val) {
        needRecal = false;
      }
    }
    if (!needRecal) {
      updated[0].raroc = "32,38%";
      updated[0].rorwa = "2,59%";
      this.setState({ products: updated });
      return;
    }
    updated[0].raroc = totalLength === 4 ? "32,38%" : "18,53%";
    updated[0].rorwa = totalLength === 4 ? "2,59%" : "1,66%";
    this.setState({ products: updated });
  };

  handleProductSelect = (index, value) => {
    const updated = [...this.state.products];
    updated[index].label = value;
    updated[index].name = "";
    updated[index].editable = true;
    this.setState({ products: updated });
  };

  addProduct = () => {
    this.setState({
      products: [
        ...this.state.products,
        {
          label: "",
          name: "",
          editable: true,
          interestRate: "",
          ead: "",
          toi: "",
          provision: "",
          cof: "",
          beforeTax: "",
          tax: "",
          afterTax: "",
          rwa: "",
          raroc: "",
          rorwa: "",
        },
      ],
    });
  };

  render() {
    const { products } = this.state;
    return (
      <div className="table-container">
        <table className="product-table">
          <thead>
            <tr>
              <th>Product name</th>
              {products.map((p, index) => (
                <th
                  key={index}
                  className={
                    index <= 2
                      ? "product-header-orange"
                      : index === 3
                        ? "product-header-blue"
                        : "product-header-green"
                  }
                >
                  {p.label === "" ? (
                    <select
                      value={p.label}
                      onChange={(e) =>
                        this.handleProductSelect(index, e.target.value)
                      }
                    >
                      <option value="">Select product</option>
                      {productOptions.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <div>
                      <div>
                        <strong>{p.label}</strong>
                      </div>
                      <div>{p.name}</div>
                    </div>
                  )}
                </th>
              ))}
              <th>
                <button onClick={this.addProduct}>➕</button>
              </th>
            </tr>
          </thead>
          <tbody>
            {rowKeys.map((key, rowIndex) => (
              <tr key={rowIndex}>
                <td className="label-cell">{rowLabels[rowIndex]}</td>
                {products.map((p, colIndex) => (
                  <td key={colIndex} className="text-right">
                    {(p.editable === true ||
                      (p.editable === "interestOnly" &&
                        key === "interestRate")) &&
                    (key !== "raroc" || key !== "rorwa") ? (
                      <input
                        type="text"
                        value={
                          key === "interestRate" && p[key].indexOf("%") < 0
                            ? `${p[key]}%`
                            : p[key]
                        }
                        onChange={(e) =>
                          this.handleInputChange(colIndex, key, e.target.value)
                        }
                      />
                    ) : (
                      p[key]
                    )}
                  </td>
                ))}
                <td></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ProductFinancialTable;



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/components/ProductFinancialTable.js